import { contentManagementService } from '../../../service';
export const setGoalsDataForTest = (packageId: string, setGoalsForTest: Function) => {
    contentManagementService.getPackageById(packageId).then((response: any) => {
        const { responseObject: { packageData: { courseDetails = [] } = {} } = {} } = response;
        courseDetails && courseDetails.length && setGoalsForTest(courseDetails);
    });
};

export const setScheduledTestFetchData = (coursePlanId: string, setScheduledTestData: Function) => {
    contentManagementService.fetchExistingScheduledTests(coursePlanId).then((response: any) => {
        const { responseObject: {
            scheduledTests = []
        } = {} } = response;
        setScheduledTestData({ scheduledTests });
    });
}
